const MODULE_NAME = 'fulcrum/container/Project/Description'

const TOGGLE_DESCRIPTION_COLLAPSE = MODULE_NAME + '/TOGGLE_DESCRIPTION_COLLAPSE'
const TOGGLE_DESCRIPTION_EDIT = MODULE_NAME + '/TOGGLE_DESCRIPTION_EDIT'
const OPEN_DESCRIPTION_EDIT = MODULE_NAME + '/OPEN_DESCRIPTION_EDIT'
const CLOSE_DESCRIPTION_EDIT = MODULE_NAME + '/CLOSE_DESCRIPTION_EDIT'
const SET_DESCRIPTION_OBJ = MODULE_NAME + '/SET_DESCRIPTION_OBJ'
const SET_DESCRIPTION = MODULE_NAME + '/SET_DESCRIPTION'
const TOGGLE_RISK = MODULE_NAME + '/TOGGLE_RISK'
const SAVE_DESCRIPTION = MODULE_NAME + '/SAVE_DESCRIPTION'
const SAVE_DESCRIPTION_ERROR = MODULE_NAME + '/SAVE_DESCRIPTION_ERROR'

const FETCH_DESCRIPTION = MODULE_NAME + '/FETCH_DESCRIPTION'
const FETCH_DESCRIPTION_START = MODULE_NAME + '/FETCH_DESCRIPTION_START'
const FETCH_DESCRIPTION_SUCCESS = MODULE_NAME + '/FETCH_DESCRIPTION_SUCCESS'
const FETCH_DESCRIPTION_ERROR = MODULE_NAME + '/FETCH_DESCRIPTION_ERROR'

export {
  MODULE_NAME,
  TOGGLE_DESCRIPTION_COLLAPSE,
  TOGGLE_DESCRIPTION_EDIT,
  OPEN_DESCRIPTION_EDIT,
  CLOSE_DESCRIPTION_EDIT,
  SET_DESCRIPTION_OBJ,
  SET_DESCRIPTION,
  TOGGLE_RISK,
  SAVE_DESCRIPTION,
  SAVE_DESCRIPTION_ERROR,
  FETCH_DESCRIPTION,
  FETCH_DESCRIPTION_START,
  FETCH_DESCRIPTION_SUCCESS,
  FETCH_DESCRIPTION_ERROR
}
